import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  EFFICIENCY_GET_REQUEST,
  EFFICIENCY_GET_SUCCESS,
  EFFICIENCY_GET_FAILURE,
  EFFICIENCY_GET_RESET,
  EFFICIENCY_LOB_GET_REQUEST,
  EFFICIENCY_LOB_GET_SUCCESS,
  EFFICIENCY_LOB_GET_FAILURE,
  EFFICIENCY_LOB_GET_RESET,
  EFFICIENCY_LOB_EXPORT_REQUEST,
  EFFICIENCY_LOB_EXPORT_SUCCESS,
  EFFICIENCY_LOB_EXPORT_FAILURE,
  EFFICIENCY_LOB_EXPORT_RESET,
  EFFICIENCY_EDIT_REQUEST,
  EFFICIENCY_EDIT_SUCCESS,
  EFFICIENCY_EDIT_FAILURE,
  EFFICIENCY_EDIT_RESET,
  EFFICIENCY_SUBMIT_REQUEST,
  EFFICIENCY_SUBMIT_SUCCESS,
  EFFICIENCY_SUBMIT_FAILURE,
  EFFICIENCY_SUBMIT_RESET,
  SHOW_MANUAL_EFFICIENCY,
  CLOSE_MANUAL_EFFICIENCY,
} from './../../constants'

export function getEfficiency(start_date, end_date, access_token, show_detail = false, lobs = '') {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/efficiency-resources?start_date=${start_date}&end_date=${end_date}&show_detail=${show_detail}${lobs !== '' ? `&lob_ids=${lobs}` : ''}`,
      method: 'GET',
      types: [
        EFFICIENCY_GET_REQUEST,
        EFFICIENCY_GET_SUCCESS,
        EFFICIENCY_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function getEfficiencyLOB(lobID, month, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/efficiency-resources/${lobID}/${month}`,
      method: 'GET',
      types: [
        EFFICIENCY_LOB_GET_REQUEST,
        EFFICIENCY_LOB_GET_SUCCESS,
        EFFICIENCY_LOB_GET_FAILURE,
      ],
      options: { timeout: (20 * 60 * 1000) },
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function exportEfficiencyLOB(lobID, month, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/efficiency-resources/${lobID}/${month}/exports`,
      method: 'GET',
      types: [
        EFFICIENCY_LOB_EXPORT_REQUEST,
        EFFICIENCY_LOB_EXPORT_SUCCESS,
        EFFICIENCY_LOB_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function editEfficiency(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/efficiency-resources/${id}`,
      method: 'PUT',
      types: [
        EFFICIENCY_EDIT_REQUEST,
        EFFICIENCY_EDIT_SUCCESS,
        EFFICIENCY_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}
export function submitEfficiency(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/efficiency-resources/submit/${id}`,
      method: 'PUT',
      types: [
        EFFICIENCY_SUBMIT_REQUEST,
        EFFICIENCY_SUBMIT_SUCCESS,
        EFFICIENCY_SUBMIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function openManual() {
  return {
    type: SHOW_MANUAL_EFFICIENCY,
  }
}
export function closeManual() {
  return {
    type: CLOSE_MANUAL_EFFICIENCY,
  }
}
export function resetGetEfficiency() {
  return {
    type: EFFICIENCY_GET_RESET,
  }
}
export function resetGetEfficiencyLOB() {
  return {
    type: EFFICIENCY_LOB_GET_RESET,
  }
}
export function resetExportEfficiencyLOB() {
  return {
    type: EFFICIENCY_LOB_EXPORT_RESET,
  }
}
export function resetEditEfficiency() {
  return {
    type: EFFICIENCY_EDIT_RESET,
  }
}
export function resetSubmitEfficiency() {
  return {
    type: EFFICIENCY_SUBMIT_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/actions/efficiency-resource/efficiency-resource-action.js